export default {
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
  'component.RightContent.profile': '个人设置',
  'component.RightContent.logout': '退出登录',
  'component.message.success.save': '保存成功',
  'component.message.error.save': '保存失败',
  'component.message.success.delete': '删除成功',
  'pages.table.column.operation': 'Operation',
};
